import React from "react";

import { DateSwitcherPropsType } from "./DateSwitcherTypes";

function formatDateForDisplay(
  dateString: string | null | undefined,
): string | null {
  if (!dateString) return null;
  const parsed = new Date(dateString);
  if (Number.isNaN(parsed.getTime())) return dateString;
  const y = parsed.getFullYear();
  const m = String(parsed.getMonth() + 1).padStart(2, "0");
  const d = String(parsed.getDate()).padStart(2, "0");
  const hh = String(parsed.getHours()).padStart(2, "0");
  const mm = String(parsed.getMinutes()).padStart(2, "0");
  return `${y}.${m}.${d} ${hh}:${mm}`;
}

function getCurrentDateString(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  const hh = String(now.getHours()).padStart(2, "0");
  const mm = String(now.getMinutes()).padStart(2, "0");
  return `${y}.${m}.${d} ${hh}:${mm}`;
}

const DateSwitcher: React.FC<DateSwitcherPropsType> = ({
  displayDate,
  canGoLeft,
  canGoRight,
  onLeft,
  onRight,
  isLoading,
}) => {
  const dateText = displayDate ?? getCurrentDateString();

  return (
    <div className="date-switcher">
      <button
        type="button"
        className="date-switcher-btn"
        onClick={onLeft}
        disabled={!canGoLeft || isLoading}
        aria-label="Предыдущая дата"
      >
        ←
      </button>
      <span className="date-switcher-date">{dateText}</span>
      <button
        type="button"
        className="date-switcher-btn"
        onClick={onRight}
        disabled={!canGoRight || isLoading}
        aria-label="Следующая дата"
      >
        →
      </button>
    </div>
  );
};

export default DateSwitcher;
export { formatDateForDisplay, getCurrentDateString };
